import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { logo } from '../assets';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("loading");
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Extract token from URL
  const token = new URLSearchParams(location.search).get("token");

  useEffect(() => {
    if (!token) {
      setStatus("invalid");
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/verify-email?token=${token}`);
        toast.success(response.data.message);
        setStatus("success");

        // Auto-redirect after verification
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setStatus("expired");
        } else {
          setStatus("error");
        }
      }
    };

    verifyEmail();
  }, [token]);

  const handleResendVerification = async () => {
    if (!email) {
      toast.error("Please enter your email!");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/send-verification-email`, { email });
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error sending verification email.");
    }

    setIsSubmitting(false);
  };

  return (
    <div className="flex max-md:flex-col w-screen h-screen">
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[35%] bg-gray-100 justify-center items-center border-r">
        <img src={logo} alt="Thirtify Logo" className="w-24 h-fit bg-gray-300 rounded-lg object-contain" />
      </div>
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[65%] overflow-y-auto scrollbar-hide justify-center items-center">
        <div className="w-full max-w-sm p-6">
          {status === "loading" && <h2 className="text-2xl font-bold text-center mb-6">Verifying your email...</h2>}
          {status === "success" && <h2 className="text-2xl font-bold text-center mb-6 text-green-600">✅ Email Verified Successfully! Redirecting...</h2>}
          {status === "expired" && (
            <div className="text-center">
              <h2 className="text-2xl font-bold mb-6 text-red-600">❌ Token Expired</h2>
              <p className="mb-4">Your verification link has expired. Please enter your email to receive a new verification link.</p>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full p-2 border border-gray-300 rounded mb-4"
                disabled={isSubmitting}
              />
              <button
                onClick={handleResendVerification}
                className={`w-full py-2 rounded text-white ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-rose-600 hover:bg-blue-700"}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Resend Verification Email"}
              </button>
            </div>
          )}
          {status === "error" && <h2 className="text-2xl font-bold text-center mb-6 text-red-600">❌ Error Verifying Email</h2>}
          {status === "invalid" && <h2 className="text-2xl font-bold text-center mb-6 text-red-600">❌ Invalid Verification Link</h2>}
          <div className="text-center mt-4">
            <button onClick={() => navigate("/login")} className="text-rose-600 hover:underline">Go to Login</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;